import { motion } from "framer-motion";

export default function Marquee({ text = "DISKO BHUTE", reverse = false }) {
  const repeated = Array.from({ length: 8 }, () => text);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.2 }}
      data-testid={`marquee-${reverse ? "reverse" : "fwd"}`}
      className="relative overflow-hidden border-y border-white/10 py-6 sm:py-10 bg-[#050505]"
    >
      <div
        className="marquee-track font-heading font-black tracking-tighter uppercase text-5xl sm:text-7xl md:text-8xl text-[#F5F5F5]/90"
        style={{
          animationDuration: "60s",
          animationDirection: "normal",
        }}
      >
        {repeated.map((t, i) => (
          <span key={i} className="mx-10 inline-flex items-center">
            <span>{t}</span>
            <span className="mx-10 inline-block w-3 h-3 bg-[#FF2A2A] rotate-45" />
          </span>
        ))}
      </div>
    </motion.div>
  );
}
